import React, { useState } from 'react';

import MyEventsTable from './MyEventsTable';

export default function MyEvents(props) {
    const [events, setEvents] = useState([]);

    const fetchEvents = async (perPage, page, sortBy, order, search) => {
        try {
            const { data: pagination } = await axios.get(props.dataUrl, {
                params: {
                    per_page: perPage,
                    page,
                    sort_by: sortBy || 'name',
                    order: order || 'asc',
                    search: search || '',
                },
            });

            const { data, ...rest } = pagination;

            setEvents(data);

            return rest; // The rest of the pagination payload drives the pager.
        } catch (error) {
            console.log(error);
        }
    };

    return <MyEventsTable events={events} fetchEvents={fetchEvents} eventDashboardUrl={props.eventDashboardUrl} />;
}
